import { getEnv } from "@/util/env.ts";

export const allowedSizes = ["original", "600x600", "500x500", "400x300", "400x400", "350x170", "330x330", "300x300", "200x200", "160x160", "100x70"];
type AllowedSize = (typeof allowedSizes)[number];

export class ImageResizer {
  static getProductImageUrl(path: string, size: AllowedSize) {
    const [brand, image] = path.split("/");
    const { PUBLIC_RESIZED_ASSETS_HOST, PUBLIC_ORIGINAL_ASSETS_HOST } = getEnv();

    if (size === "original") {
      return removeDevSubdomain(PUBLIC_ORIGINAL_ASSETS_HOST) + "/" + brand + "/" + image;
    }

    return removeDevSubdomain(PUBLIC_RESIZED_ASSETS_HOST) + "/" + size + "/" + brand + "::" + image;
  }
}

function removeDevSubdomain(url: string): string {
  return url.replace(".dev.", ".");
}
